import React from 'react';
import { HTML_DOC_TYPE, DOC_TYPE_VOTE } from '../../../helpers/constants';
import { checkURL } from '../../../helpers/utils';
import store from '../../../stores/store';

class DocumentLink extends React.Component {
    openDocument = () => {
        const document = this.props.document;

        store.documents
            .fetchDocument({
                instanceId: this.props.instanceId,
                docTypeId: DOC_TYPE_VOTE,
                docId: document.VoteDocId,
                DocExtension: document.DocExtension,
                DocPermissions: document.DocPermissions,
                DocName: document.DocName,
                DocAnnotations: document.DocAnnotations,
            })
            .catch(error => {
                console.log('error fetching doc - Link');
            });
    };

    render() {
        const document = this.props.document;
        const extension = '.' + document.DocExtension;

        const docUrl = document.DocUrl;
        // const name = document.DocName;
        const type = document.docType;

        return (
            <tr>
                <th scope="row">Attachments:</th>
                <td>
                    {type === HTML_DOC_TYPE ? (
                        <a
                            className={'doc-clickable-block'}
                            target="__blank"
                            title={extension}
                            href={checkURL(docUrl)}
                        >
                            {docUrl}
                        </a>
                    ) : (
                        <div
                            className={'doc-clickable-block'}
                            onClick={this.openDocument}
                            title={extension}
                        >
                            {document.DocName}
                        </div>
                    )}
                </td>
            </tr>
        );
    }
}

export default DocumentLink;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Vote/DocumentLink.js